export default {"src":"https://s.sylndr.com/c-3732c05/_next/static/media/arrowAnimate.2b21d88b.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};